module.exports = __webpack_public_path__ + "static/leeds-tv-sm-f505bc383ac9ba2a52221855ab8994b1.png";